import React from 'react';
import EmpRow from './EmpRow/index';

const EmpList = ({ width, data, addFavouriteEmp, onEmpSelect, onSaveEmp, onDeleteEmp, showEmpLoader }) => {
    return (
        <div className="app-main-content">
            {data.map((data, index) =>
                <EmpRow key={index} width={width} employee={data} onDeleteEmp={onDeleteEmp}
                    onSaveEmp={onSaveEmp} showEmpLoader={showEmpLoader}
                    addFavouriteEmp={addFavouriteEmp} onEmpSelect={onEmpSelect}
                />
            )}

        </div>
    );
};

export default EmpList;


// WEBPACK FOOTER //
// ./components/Agile/Employee/EmpList/index.js